import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RequestQuoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"request_quote"}/>
}
